import { Component } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { DatePipe } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TableHeadComponent } from '../table-head/table-head.component';
import { TableModule } from 'primeng/table';
import { ToastsContainerComponent } from '@shared/services/toastService/toast-container.component';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastsContainerComponent,
    SidebarComponent,
    MenuComponent,
  ],
  templateUrl: './root.component.html',
  styleUrl: './root.component.scss'
})
export class RootComponent {

}
